import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Card } from '@uhg-abyss/web/ui/Card';
import { PageLayout } from '@src/common/PageLayout';
import { Button } from '@src/common/Button';

const MAX_ADDRESSES = 5;

const Text = styled('p', {
  lineHeight: '22px',
  marginBottom: '20px',
});

export const AddSecondaryServicing = ({
  addressCount,
  handleAddSecondaryAddress,
}) => {
  return (
    <PageLayout>
      <Card header="Secondary servicing address (optional)">
        <Card.Section>
          <Text>
            Provide any secondary servicing addresses you may have, up to five.
            All addresses used to submit claims are required.
          </Text>
          <Button
            type="button"
            aria-label="click here to check TIN registration status"
            data-testid="start-button"
            onClick={handleAddSecondaryAddress}
            variant="outline"
            style={{
              borderColor:
                addressCount === MAX_ADDRESSES ? 'rgb(229, 229, 229)' : '',
            }}
            isDisabled={addressCount === MAX_ADDRESSES}
          >
            Add Secondary Servicing Address
          </Button>
        </Card.Section>
      </Card>
    </PageLayout>
  );
};

AddSecondaryServicing.propTypes = {
  addressCount: PropTypes.number.isRequired,
  handleAddSecondaryAddress: PropTypes.func.isRequired,
};
